import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import { PublicLayout } from './BookPage';
import { Scale } from 'lucide-react';

const spring = { type: 'spring', stiffness: 300, damping: 20 };
const SECTIONS = [1, 2, 3, 4, 5, 6, 7];

export default function LegalPage() {
  const { t } = useI18n();
  return (
    <PublicLayout testid="legal-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={spring} className="max-w-3xl">
        <p className="text-or-400 font-bold tracking-widest text-sm uppercase flex items-center gap-2">
          <Scale className="w-4 h-4" strokeWidth={2.5} /> {t('legal.eyebrow')}
        </p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-creme mt-3" data-testid="legal-title">
          {t('legal.title')}
        </h1>
        <p className="text-base text-brume mt-4 leading-relaxed" data-testid="legal-intro">{t('legal.intro')}</p>
        <div className="space-y-8 mt-10">
          {SECTIONS.map((n) => (
            <section key={n} data-testid={`legal-section-${n}`}>
              <h2 className="text-xl font-semibold text-or-300 font-fredoka mb-2">{t(`legal.s${n}Title`)}</h2>
              <p className="text-base text-brume leading-relaxed whitespace-pre-line">{t(`legal.s${n}Body`)}</p>
              {n === 5 && (
                <Link to="/confidentialite" data-testid="legal-privacy-link"
                  className="inline-block mt-2 text-or-400 font-bold hover:text-or-300 hover:underline">
                  {t('footer.privacy')} →
                </Link>
              )}
            </section>
          ))}
        </div>
      </motion.div>
    </PublicLayout>
  );
}
